import CustomReportChannel from '@/Enums/ReportBuilder/ReportChannel.enum';
import { PRIMARY } from '@/constants/color';
import { BUTTON_TAB_ID } from '@/constants/reportBuilder';
import { a11yProps } from '@/utils/tabProps';
import { Divider, Tab, Tabs, tabClasses, tabsClasses } from '@mui/material';
import { FC, SyntheticEvent } from 'react';
import { TabButton } from './TabButtons';

interface IApiTabsProps {
  currentTab: CustomReportChannel;
  visibleTabs: CustomReportChannel[];
  onTabChange: (event: SyntheticEvent, newValue: CustomReportChannel) => void;
}

const ApiTabs: FC<IApiTabsProps> = ({ currentTab, visibleTabs, onTabChange }) => {
  return (
    <div className='mb-5'>
      <Tabs
        // `false` avoids MUI's unmatched-value warning before `currentTab` is clamped.
        value={visibleTabs.includes(currentTab) ? currentTab : false}
        orientation='horizontal'
        onChange={onTabChange}
        aria-label='reporting api tabs'
        sx={{
          minHeight: 'unset',
          [`& .${tabsClasses.flexContainer}`]: {
            justifyContent: 'space-between',
            gap: '8px',
          },
          [`& .${tabClasses.root}`]: {
            flex: 1,
            minHeight: 'unset',
            paddingLeft: '16px',
            paddingRight: '16px',
            borderRadius: '8px 8px 0 0',
            fontSize: '21px',
            fontWeight: 700,
            maxWidth: 'unset',
            padding: 0,
            borderBottom: `8px solid transparent`,
          },
          [`& .${tabClasses.selected}`]: {
            background: '#1B43321F',
            borderBottomColor: PRIMARY,
          },
        }}
        slotProps={{
          indicator: {
            hidden: true,
          },
        }}
      >
        {/* Explicit `value`: MUI otherwise infers it from child position, which shifts when a tab is hidden. */}
        {visibleTabs.map(channel => (
          <Tab
            key={channel}
            value={channel}
            component={TabButton}
            channel={channel}
            {...a11yProps(channel, BUTTON_TAB_ID)}
          />
        ))}
      </Tabs>
      <Divider sx={{ marginX: '-30px' }} />
    </div>
  );
};

export default ApiTabs;
